import AdminLayout from "../layouts/AdminLayout";
import Dashboard from "../pages/admin/Dashboard/Dashboard";
import { Category } from "../pages/admin/Category/Category";
import UserList from "../pages/admin/User/UserList";
import UserDetails from "../pages/admin/User/UserDetails";
import { Report } from "../pages/admin/Report/Report";
import ChangePassword from "../pages/admin/ChangePassword/ChangePassword";
import Posts from "../pages/admin/Post/Posts";
import PostDetails from "../pages/admin/Post/PostDetails";
import Stories from "../pages/admin/Story/Stories";
import StoriesDetails from "../pages/admin/Story/StoriesDetails";
import Blogs from "../pages/admin/Blog/Blogs";
import BlogDetails from "../pages/admin/Blog/BlogDetails";
import ProtectedRoute from "../components/ProtectedRoute";
import Login from "../pages/auth/Login";
import FeedBack from "../pages/admin/FeedBack/Feedback";

export const Path = {
  Login: "/login",
  AdminRoot: "/admin",
};

export const AuthRoutes = [
  {
    path: Path.Login,
    element: <Login />,
  },
];

export const AdminRoutes = {
  path: Path.AdminRoot,
  element: (
    <ProtectedRoute>
      <AdminLayout />
    </ProtectedRoute>
  ),
  children: [
    { index: true, element: <Dashboard /> },
    { path: "dashboard", element: <Dashboard /> },
    { path: "category", element: <Category /> },
    { path: "user/user-list", element: <UserList /> },
    { path: "user/userDetails", element: <UserDetails /> },
    { path: "report", element: <Report /> },
    { path: "change-password", element: <ChangePassword /> },
    { path: "post/Posts", element: <Posts /> },
    { path: "post/postDetails", element: <PostDetails /> },
    { path: "story/stories", element: <Stories /> },
    { path: "story/storiesdetails", element: <StoriesDetails /> },
    { path: "blog/blogs", element: <Blogs /> },
    { path: "blog/blogdetails", element: <BlogDetails /> },
    { path: "feedBack/feedback", element: <FeedBack /> },
  ],
};
